import { ANNOTATION_LABELS } from '../../../common/constant/constant';
import useStorage from '../../../common/hooks/useStorage';
import { useOnceEffect } from '../../hooks/use-once-effect';
import { useAnnotationLabel } from './use-annotation-labels';
import { useDispatch } from './use-dispatch';
export const useInitializeLabelColors = () => {
  const dispatch = useDispatch();
  const {
    get
  } = useStorage();
  const annotationLabels = useAnnotationLabel();
  useOnceEffect(() => {
    // we only want to update the color of labels based on what is stored in local storage once.
    const titleStyleMap = get(ANNOTATION_LABELS);
    if (!titleStyleMap) return;
    const titleStyleMapObj = JSON.parse(titleStyleMap);
    const updatedAnnotationLabels = annotationLabels.map(annotationLabel => {
      const storedStyle = titleStyleMapObj[annotationLabel.title];
      if (storedStyle) {
        return {
          ...annotationLabel,
          style: {
            ...annotationLabel.style,
            strokeColor: (storedStyle as any).strokeColor ?? (storedStyle as any).fillColor,
            fillColor: (storedStyle as any).fillColor
          }
        };
      }
      return annotationLabel;
    });
    dispatch({
      type: 'UPDATE_ALL_ANNOTATION_LABELS',
      annotationLabels: updatedAnnotationLabels
    });
  });
};